import { TFunction } from 'i18next'
import * as yup from 'yup'

export const createPhoneSchema = (t: TFunction) => {
  return yup.object({
    mobile_phone: yup
      .string()
      .trim()
      .min(11, t('min_length_phone', { ns: 'auth' }) as string)
      .required(t('required_field', { ns: 'auth' }) as string)
  })
}
